import GoogleMapWithCluster, {
  MarkerInfo,
} from "@sellernote/ui/src/common-components/googleMap/GoogleMapWithCluster";

import Styled from "./index.styles";

/**
 * 마이페이지 > 운송관리 > 사이드시트 > 운송현황의 Map을 다른 페이지에서도 사용하기 위해 추출한 컴포넌트
 */
export default function BLTrackingMap({
  keyId,
  paddingTop,
  zoom,
  minZoom,
  pinCenter,
  markerInfoList,
  polylineInfo,
  dashedPolylineInfo,
  totalPolylineData,
  isError,
}: {
  keyId: string | number;
  paddingTop?: string;
  zoom?: number;
  minZoom?: number;
  pinCenter?: {
    lat: number;
    lng: number;
  };
  markerInfoList?: MarkerInfo[];
  polylineInfo?: google.maps.PolylineOptions;
  dashedPolylineInfo?: google.maps.PolylineOptions;
  totalPolylineData?: google.maps.PolylineOptions;
  isError?: boolean;
}) {
  const infoMarkerWidthSize = 80;
  const infoMarkerHeightSize = 45;

  return (
    // 동일구간일 때 데이터가 변하지 않아 지도 렌더링이 중복되는 에러가 발생해 key를 추가
    <Styled.container key={keyId}>
      <GoogleMapWithCluster
        paddingTop={paddingTop}
        pinCenter={pinCenter}
        markerInfoList={markerInfoList}
        zoom={zoom}
        minZoom={minZoom}
        isAutoZoom={true}
        boundsPadding={{
          top: infoMarkerHeightSize,
          right: infoMarkerWidthSize,
          bottom: infoMarkerHeightSize,
          left: infoMarkerWidthSize,
        }}
        polylineInfo={polylineInfo}
        dashedPolylineInfo={dashedPolylineInfo}
        totalPolylineData={totalPolylineData}
        hasError={isError}
      />
    </Styled.container>
  );
}
